import { Component, EventEmitter, Output, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { LocationService } from '../../../auth/guard/auth/guard/location.service';

@Component({
  selector: 'app-map',
  standalone: true,
  imports: [CommonModule, GoogleMapsModule],
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss',
})
export class MapComponent implements OnInit {
  @Output() locationChange = new EventEmitter<{ lat: string; long: string }>();

  center: google.maps.LatLngLiteral = { lat: 40.73061, lng: -73.935242 };
  zoom = 12;
  marker: google.maps.LatLngLiteral = this.center;

  private locationService = inject(LocationService);

  ngOnInit() {
    this.locationService
      .getUserLocation()
      .then(({ latitude, longitude }) => {
        this.center = { lat: latitude, lng: longitude };
        this.marker = this.center;
      })
      .catch((err) => {
        console.warn('Could not get user location:', err);
      });
  }

  mapOptions = {
    center: this.center,
    zoom: this.zoom,
  };

  onMapClick(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      this.marker = { lat, lng };
      this.locationChange.emit({
        lat: lat.toString(),
        long: lng.toString(),
      });
    }
  }
}
